export default __webpack_public_path__ + "static/media/pictogramTravel64.434b93fa.svg";